import React from 'react';
import { 
  FaDownload, 
  FaEye, 
  FaCar, 
  FaMotorcycle, 
  FaWrench,
  FaCheckCircle,
  FaFileContract,
  FaUsers,
  FaClock,
  FaAward
} from 'react-icons/fa';
import './Contracts.css';

function Contracts() {
  // Configuração dos tipos de contratos
  const contractTypes = [
    {
      id: 'rastreamento',
      title: 'Rastreamento Veicular',
      description: 'Sistema completo de rastreamento com monitoramento em tempo real, histórico de rotas e relatórios detalhados.',
      icon: <FaCar className="contract-icon" />,
      features: [
        'Monitoramento em tempo real',
        'Histórico de rotas',
        'Relatórios detalhados',
        'Suporte 24/7',
        'App mobile exclusivo'
      ],
      modelUrl: '/modelos/RastreamentoVeicular.pdf',
      color: '#1a3a8f'
    },
    {
      id: 'plano_moto_plus',
      title: 'Plano Moto +',
      description: 'Sua moto protegida, assistida e sempre pronta para rodar — rastreamento 24h, assistência completa e benefícios exclusivos de oficina.',
      icon: <FaMotorcycle className="contract-icon" />,
      features: [
        'Rastreamento 24h e bloqueio via app',
        'Assistência 24h (reboque, chaveiro e panes)',
        '3 revisões e 3 lavagens ao ano',
        '1 bateria nova ao ano',
        'AirTag e antifurto em comodato'
      ],
      modelUrl: '/modelos/RastreamentoVeicular_Sensor.pdf',
      color: '#0056b3'
    },
    {
      id: 'assistencia',
      title: 'Assistência Veicular',
      description: 'Cobertura completa de assistência veicular com suporte emergencial e serviços especializados.',
      icon: <FaWrench className="contract-icon" />,
      features: [
        'Reboque 24 horas',
        'Auxílio a pane seca',
        'Chaveiro especializado',
        'Borracheiro',
        'Auxílio a pane elétrica'
      ],
      modelUrl: '/modelos/AssistenciaVeicular.pdf',
      color: '#28a745'
    }
  ];

  const stats = [
    { number: "1000+", label: "Contratos Ativos" },
    { number: "99.9%", label: "Taxa de Aprovação" },
    { number: "24/7", label: "Suporte Jurídico" },
    { number: "10+", label: "Anos de Experiência" }
  ];

  const benefits = [
    {
      icon: <FaFileContract />,
      title: "Contratos Transparentes",
      description: "Termos claros e objetivos, sem surpresas ou cláusulas ocultas"
    },
    {
      icon: <FaUsers />,
      title: "Suporte Especializado",
      description: "Equipe jurídica dedicada para esclarecer todas as suas dúvidas"
    },
    {
      icon: <FaClock />,
      title: "Processo Ágil",
      description: "Assinatura digital e aprovação em tempo recorde"
    },
    {
      icon: <FaAward />,
      title: "Qualidade Garantida",
      description: "Contratos revisados e aprovados por especialistas"
    }
  ];

  const handleModelDownload = (modelUrl, contractTitle) => {
    try {
      const link = document.createElement('a');
      link.href = modelUrl;
      link.download = `contrato-${contractTitle.toLowerCase().replace(/\s+/g, '-')}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert('Erro ao fazer download do contrato. Tente novamente.');
    }
  };

  const handleModelView = (modelUrl) => {
    try {
      window.open(modelUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      alert('Erro ao visualizar o contrato. Tente novamente.');
    }
  };

  return (
    <div className="contracts-page">
      {/* Hero Section */}
      <section className="contracts-hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
        </div>
        <div className="contracts-hero-content">
          <div className="hero-badge">
            <FaFileContract className="badge-icon" />
            <span>Contratos Profissionais</span>
          </div>
          <h1>Nossos Contratos</h1>
          <p>Modelos transparentes e profissionais para todos os nossos serviços, com termos claros e suporte jurídico especializado</p>
          <div className="hero-stats">
            {stats.map((stat, index) => (
              <div className="stat-item" key={index}>
                <span className="stat-number">{stat.number}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contracts Grid Section */}
      <section className="contracts-grid-section">
        <div className="section-header">
          <h2>Modelos de Contratos</h2>
          <p>Escolha o tipo de serviço que melhor atende suas necessidades e visualize o contrato correspondente</p>
        </div>
        
        <div className="contracts-container">
          {contractTypes.map((contract, index) => (
            <div className="contract-card" key={index}>
              
              <div className="contract-header">
                <div className="contract-icon-wrapper" style={{ background: contract.color }}>
                  {contract.icon}
                </div>
                <h3>{contract.title}</h3>
              </div>
              
              <div className="contract-description">
                {contract.description}
              </div>
              
              <div className="contract-features">
                <h4>Principais Benefícios:</h4>
                <ul>
                  {contract.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>
                      <FaCheckCircle className="feature-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="contract-actions">
                <button 
                  className="contract-button primary"
                  onClick={() => handleModelView(contract.modelUrl)}
                >
                  <FaEye className="button-icon" />
                  Visualizar
                </button>
                <button 
                  className="contract-button secondary"
                  onClick={() => handleModelDownload(contract.modelUrl, contract.title)}
                >
                  <FaDownload className="button-icon" />
                  Download
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="benefits-background">
          <div className="benefits-pattern"></div>
        </div>
        <div className="benefits-content">
          <div className="section-header light">
            <h2>Por que Nossos Contratos?</h2>
            <p>Transparência, qualidade e suporte especializado em todos os nossos acordos</p>
          </div>
          
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div className="benefit-card" key={index}>
                <div className="benefit-icon-wrapper">
                  {benefit.icon}
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-background">
          <div className="cta-pattern"></div>
        </div>
        <div className="cta-content">
          <div className="section-header light">
            <h2>Pronto para Começar?</h2>
            <p>Entre em contato conosco para esclarecer dúvidas sobre nossos contratos e serviços</p>
          </div>
          
          <div className="cta-actions">
            <button className="cta-button primary" onClick={() => window.location.href = '/contact'}>
              <FaUsers className="button-icon" />
              Falar com Consultor
            </button>
            <button className="cta-button secondary" onClick={() => {
              const message = encodeURIComponent('Olá! Tenho interesse nos serviços da G3 Rastreamento e gostaria de agendar uma reunião para conhecer melhor as soluções oferecidas. Podem me ajudar?');
              const whatsappUrl = `https://wa.me/5585999835383?text=${message}`;
              window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
            }}>
              <FaClock className="button-icon" />
              Agendar Reunião
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contracts;